import { isAuthenticated } from 'modules/common/permissions';

import VectorEditorPage from '../entry';
import { initVectorEditor } from './sagas';

export default [
  {
    component: VectorEditorPage,
    exact: true,
    path: '/vectorEditor/',
    permissions: [isAuthenticated],
    saga: initVectorEditor,
  },
];
